import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonandedcabservice() {



    const cardData = {

keyword: "Pune to Nanded Cab Service",

headingDescription:
    "Rising Cab Service offers safe and reliable Pune to Nanded Cab Service for families, pilgrims, business travelers, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a comfortable long-distance journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for religious visits, business, or family trips, Rising Cab Service ensures a smooth and hassle-free journey from Pune to Nanded.",

topPlaces: [
    {
        title: "Hazur Sahib Gurudwara",
        description:
            "Takht Sri Hazur Sahib is one of the five sacred Takhts of Sikhism and the most famous landmark in Nanded. Built in memory of Guru Gobind Singh Ji, it attracts devotees from across the world."
    },
    {
        title: "Nanded Fort",
        description:
            "Nanded Fort is a historic structure located on the banks of the Godavari River. It reflects the region's rich heritage and offers beautiful views of the surrounding area."
    },
    {
        title: "Kaleshwar Temple",
        description:
            "Kaleshwar Temple is a revered Hindu temple dedicated to Lord Shiva and is known for its peaceful atmosphere and spiritual importance."
    },
    {
        title: "Sahasrakund Waterfall",
        description:
            "Sahasrakund Waterfall is one of the largest waterfalls in the region, located on the Godavari River and admired for its scenic beauty, especially during the monsoon season."
    },
    {
        title: "Kandhar Fort",
        description:
            "Kandhar Fort is an ancient fort near Nanded known for its massive walls, historical architecture, and archaeological significance."
    },
    {
        title: "Unkeshwar Hot Springs",
        description:
            "Unkeshwar is a popular pilgrimage and tourist destination famous for its natural hot water springs and ancient Shiva temple."
    },
    {
        title: "Malegaon Yatra",
        description:
            "Malegaon near Nanded is known for its traditional fairs and religious events, attracting visitors from different parts of Maharashtra."
    },
    {
        title: "Vishnupuri Dam",
        description:
            "Vishnupuri Dam on the Godavari River is a scenic destination known for its calm surroundings and irrigation importance in the region."
    },
    {
        title: "Renuka Devi Temple Mahur",
        description:
            "Mahur is a famous pilgrimage destination near Nanded and home to the revered Renuka Devi Temple, one of the important Shakti Peeths in Maharashtra."
    },
    {
        title: "Mahur Fort",
        description:
            "Mahur Fort is a historic hill fort near Nanded offering panoramic views of the surrounding forests and valleys while showcasing the region's rich heritage."
    }
],



services: [
    {
        name: "Pune to Nanded Cab",
        description:
            "Rising Cab Service offers Pune to Nanded Cab for safe, comfortable, and reliable long-distance travel across Maharashtra. Whether you are visiting for business, family functions, religious tours, or tourism, we provide well-maintained AC vehicles including sedans, SUVs, Innova, and Innova Crysta with experienced highway drivers. Customers can choose one-way, round-trip, and customized travel plans with doorstep pickup and drop service. Our 24x7 booking support, transparent pricing, and professional chauffeurs ensure a smooth and hassle-free journey from Pune to Nanded and nearby Marathwada destinations."
    },
    {
        name: "Pune to Nanded Taxi",
        description:
            "Book Pune to Nanded Taxi with Rising Cab Service for affordable and comfortable intercity travel with experienced drivers, clean vehicles, and flexible travel schedules."
    },
    {
        name: "Cab from Pune to Nanded",
        description:
            "Our Cab from Pune to Nanded provides convenient door-to-door transportation for business travelers, families, and tourists with safe highway travel and professional service."
    },
    {
        name: "Taxi from Pune to Nanded",
        description:
            "Rising Cab Service offers Taxi from Pune to Nanded with punctual pickups, comfortable AC vehicles, and reliable long-distance travel solutions."
    },
    {
        name: "Pune to Nanded Cab Service",
        description:
            "Our Pune to Nanded Cab Service ensures smooth and hassle-free travel with one-way and round-trip options, experienced drivers, and well-maintained vehicles."
    },
    {
        name: "Pune to Nanded Taxi Fare",
        description:
            "Get transparent Pune to Nanded Taxi Fare with competitive pricing and no hidden charges for one-way, round-trip, and customized travel plans."
    },
    {
        name: "Pune to Nanded One Way Cab",
        description:
            "Book Pune to Nanded One Way Cab for economical point-to-point travel with comfortable vehicles and experienced highway drivers."
    },
    {
        name: "Pune to Nanded Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Nanded Round Trip Taxi with flexible return timing and waiting facilities for business and family travel."
    },
    {
        name: "Pune to Nanded Cab Booking",
        description:
            "Our Pune to Nanded Cab Booking service offers instant confirmation, multiple vehicle options, and reliable customer support available 24x7."
    },
    {
        name: "Cheap Pune to Nanded Cab",
        description:
            "Book Cheap Pune to Nanded Cab for budget-friendly travel without compromising comfort, safety, or service quality."
    },
    {
        name: "Best Pune to Nanded Taxi",
        description:
            "Choose the Best Pune to Nanded Taxi with Rising Cab Service for premium comfort, punctual service, and experienced chauffeurs."
    },
    {
        name: "Sedan Pune to Nanded Cab",
        description:
            "Our Sedan Pune to Nanded Cab is perfect for solo travelers and small families seeking economical and comfortable long-distance travel."
    },
    {
        name: "SUV Pune to Nanded Taxi",
        description:
            "Book SUV Pune to Nanded Taxi for spacious seating, additional luggage capacity, and comfortable family or group travel."
    },
    {
        name: "Innova Pune to Nanded Cab",
        description:
            "Rising Cab Service offers Innova Pune to Nanded Cab with premium comfort and spacious interiors for group and family journeys."
    },
    {
        name: "Long Route Cab Pune Nanded",
        description:
            "Our Long Route Cab Pune Nanded service provides safe and reliable highway travel with experienced drivers and comfortable AC vehicles."
    },
    {
        name: "Pune to Marathwada Cab",
        description:
            "Rising Cab Service provides Pune to Marathwada Cab for travel to major cities across the Marathwada region with flexible one-way and round-trip options."
    },
    {
        name: "Marathwada Cab Service from Pune",
        description:
            "Book Marathwada Cab Service from Pune for business trips, family travel, and tourism with reliable drivers and comfortable vehicles."
    },
    {
        name: "Pune to Marathwada Taxi Service",
        description:
            "Our Pune to Marathwada Taxi Service offers safe and affordable transportation to various Marathwada destinations with customized travel plans."
    },
    {
        name: "Pune to Marathwada Cab Booking",
        description:
            "Rising Cab Service offers Pune to Marathwada Cab Booking with instant confirmation and multiple vehicle choices."
    },
    {
        name: "Best Marathwada Cab Pune",
        description:
            "Choose the Best Marathwada Cab Pune for reliable long-distance travel with experienced chauffeurs and premium travel comfort."
    },
    {
        name: "Outstation Cab Pune to Marathwada",
        description:
            "Our Outstation Cab Pune to Marathwada service provides convenient and comfortable travel for individuals, families, and corporate clients."
    },
    {
        name: "Luxury Cab Pune Marathwada",
        description:
            "Book Luxury Cab Pune Marathwada with premium vehicles including Innova Crysta for a superior travel experience."
    },
    {
        name: "Pune to Marathwada Tour Cab",
        description:
            "Rising Cab Service offers Pune to Marathwada Tour Cab for sightseeing, pilgrimage, and family vacations across the region."
    },
    {
        name: "Round Trip Marathwada Taxi Pune",
        description:
            "Our Round Trip Marathwada Taxi Pune service provides flexible return schedules and customized travel itineraries."
    },
    {
        name: "One Way Pune to Marathwada Cab",
        description:
            "Book One Way Pune to Marathwada Cab for economical point-to-point travel with transparent pricing."
    },
    {
        name: "Pune to Jalna Cab",
        description:
            "Rising Cab Service provides Pune to Jalna Cab with safe, comfortable, and reliable long-distance transportation."
    },
    {
        name: "Pune to Jalna Cab Service",
        description:
            "Our Pune to Jalna Cab Service ensures convenient travel with experienced drivers and well-maintained vehicles."
    },
    {
        name: "Pune to Jalna Taxi Service",
        description:
            "Book Pune to Jalna Taxi Service for affordable and dependable intercity transportation."
    },
    {
        name: "Pune to Jalna Cab Booking",
        description:
            "Rising Cab Service offers Pune to Jalna Cab Booking with instant confirmation and flexible travel options."
    },
    {
        name: "Best Pune to Jalna Cab",
        description:
            "Choose the Best Pune to Jalna Cab for comfortable and stress-free highway travel."
    },
    {
        name: "One Way Pune to Jalna Cab",
        description:
            "Our One Way Pune to Jalna Cab provides economical long-distance travel with doorstep pickup and drop."
    },
    {
        name: "Round Trip Pune to Jalna Taxi",
        description:
            "Book Round Trip Pune to Jalna Taxi with flexible return schedules and waiting facilities."
    },
    {
        name: "Pune to Hingoli Cab",
        description:
            "Rising Cab Service offers Pune to Hingoli Cab with safe and reliable intercity travel solutions."
    },
    {
        name: "Pune to Hingoli Cab Service",
        description:
            "Our Pune to Hingoli Cab Service provides comfortable long-distance travel for business and family trips."
    },
    {
        name: "Pune to Hingoli Taxi Service",
        description:
            "Book Pune to Hingoli Taxi Service with experienced drivers and affordable pricing."
    },
    {
        name: "Pune to Hingoli Cab Booking",
        description:
            "Rising Cab Service offers Pune to Hingoli Cab Booking with instant reservations and 24x7 support."
    },
    {
        name: "Best Pune to Hingoli Cab",
        description:
            "Choose the Best Pune to Hingoli Cab for smooth and comfortable travel."
    },
    {
        name: "One Way Pune to Hingoli Cab",
        description:
            "Our One Way Pune to Hingoli Cab provides budget-friendly point-to-point travel."
    },
    {
        name: "Round Trip Pune to Hingoli Taxi",
        description:
            "Book Round Trip Pune to Hingoli Taxi with flexible return plans and comfortable vehicles."
    },
    {
        name: "Cheap Pune to Hingoli Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Hingoli Cab with economical pricing and dependable service."
    },
    {
        name: "Pune to Latur Cab Booking",
        description:
            "Our Pune to Latur Cab Booking service provides instant confirmation and reliable transportation."
    },
    {
        name: "Pune to Latur Cab Service",
        description:
            "Rising Cab Service offers Pune to Latur Cab Service for safe, comfortable, and affordable long-distance travel."
    }
],

tableData: [
    ["Pune to Nanded Cab", "Pune to Nanded Taxi"],
    ["Cab from Pune to Nanded", "Taxi from Pune to Nanded"],
    ["Pune to Nanded Cab Service", "Pune to Nanded Taxi Fare"],
    ["Pune to Nanded One Way Cab", "Pune to Nanded Round Trip Taxi"],
    ["Pune to Nanded Cab Booking", "Cheap Pune to Nanded Cab"],
    ["Best Pune to Nanded Taxi", "Sedan Pune to Nanded Cab"],
    ["SUV Pune to Nanded Taxi", "Innova Pune to Nanded Cab"],
    ["Long Route Cab Pune Nanded", "Pune to Marathwada Cab"],
    ["Marathwada Cab Service from Pune", "Pune to Marathwada Taxi Service"],
    ["Pune to Marathwada Cab Booking", "Best Marathwada Cab Pune"],
    ["Outstation Cab Pune to Marathwada", "Luxury Cab Pune Marathwada"],
    ["Pune to Marathwada Tour Cab", "Round Trip Marathwada Taxi Pune"],
    ["One Way Pune to Marathwada Cab", "Pune to Jalna Cab"],
    ["Pune to Jalna Cab Service", "Pune to Jalna Taxi Service"],
    ["Pune to Jalna Cab Booking", "Best Pune to Jalna Cab"],
    ["One Way Pune to Jalna Cab", "Round Trip Pune to Jalna Taxi"],
    ["Pune to Hingoli Cab", "Pune to Hingoli Cab Service"],
    ["Pune to Hingoli Taxi Service", "Pune to Hingoli Cab Booking"],
    ["Best Pune to Hingoli Cab", "One Way Pune to Hingoli Cab"],
    ["Round Trip Pune to Hingoli Taxi", "Cheap Pune to Hingoli Cab"],
    ["Pune to Latur Cab Booking", "Pune to Latur Cab Service"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Nanded Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Nanded cab transportation for pilgrims, families, business travelers, students, and tourists seeking a smooth long-distance journey."
    },
    {
        WhyChooseheading: "Perfect for Religious and Spiritual Travel",
        WhyChoosedescription: "Many devotees choose our cab service to visit Hazur Sahib Gurudwara, one of the most sacred Sikh pilgrimage destinations in India."
    },
    {
        WhyChooseheading: "Comfortable Travel for Long-Distance Routes",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles to ensure a relaxing travel experience."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can book one-way transfers, return journeys, multi-day travel packages, or customized itineraries according to their travel schedule."
    },
    {
        WhyChooseheading: "Suitable for Family and Group Travel",
        WhyChoosedescription: "Whether traveling with family, friends, religious groups, or corporate teams, we provide vehicle options suitable for every group size."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune and PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Interstate Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with long-distance routes and ensure safe, comfortable, and efficient travel throughout the journey."
    },
    {
        WhyChooseheading: "Customized Travel and Sightseeing Plans",
        WhyChoosedescription: "Travelers can include religious sites, family destinations, sightseeing spots, and additional city stops according to their preferences."
    }
]
};

const faqData = [
    {
        question: "Why is Nanded a popular destination from Pune?",
        answer: "Nanded is famous for Hazur Sahib Gurudwara, historical landmarks, educational institutions, and its significance as an important religious and cultural destination."
    },
    {
        question: "Can I book a one-way cab from Pune to Nanded?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is recommended for Pune to Nanded travel?",
        answer: "Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices for long-distance comfort and luggage space."
    },
    {
        question: "Do you provide cabs for Hazur Sahib Darshan?",
        answer: "Yes, many devotees use our Pune to Nanded cab service specifically for Hazur Sahib Gurudwara visits and religious tours."
    },
    {
        question: "Can families travel comfortably on this route?",
        answer: "Yes, spacious vehicles with comfortable seating make the journey suitable for families, children, and senior citizens."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for religious groups, family tours, and group travel."
    },
    {
        question: "Can multiple destinations be included during the trip?",
        answer: "Yes, customized itineraries can include nearby temples, gurudwaras, tourist attractions, and personal travel stops."
    },
    {
        question: "Is same-day return travel available from Nanded?",
        answer: "Multi-day travel is generally preferred, but return packages can be customized according to customer requirements."
    },
    {
        question: "Can passengers start the journey from Pune Airport or Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I reserve a Pune to Nanded Cab Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Harpreet Singh",
        feedback:
            "Our family pilgrimage to Hazur Sahib was extremely comfortable with Rising Cab Service. The vehicle was clean, the driver was courteous, and the journey was managed very professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Aarti Deshmukh",
        feedback:
            "Traveling from Pune to Nanded for a family function became completely stress-free. The cab was spacious, the ride was smooth, and the overall service exceeded our expectations.",
        rating: 5
    }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Nanded Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-nanded-cab.jpg",
"description": "Book Pune to Nanded Cab Service with Rising Cab Service for safe, comfortable, and long-distance travel across Marathwada. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-nanded-cab"
}
};




    return (
        <div>


<Helmet>
  <title>Pune to Nanded Cab Service | Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Nanded Cab Service for safe and comfortable long-distance travel in Marathwada. Get affordable one-way and round-trip taxi service with sedan, SUV, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to nanded cab, pune to nanded taxi, cab from pune to nanded, taxi from pune to nanded, pune to nanded cab service, pune to nanded taxi fare, pune to nanded one way cab, pune to nanded round trip taxi, pune to nanded cab booking, cheap pune to nanded cab, best pune to nanded taxi, sedan pune to nanded cab, suv pune to nanded taxi, innova pune to nanded cab, long route cab pune nanded, Pune to Marathwada Cab, Marathwada Cab Service from Pune, Pune to Marathwada Taxi Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonandedcabservice;